var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloudRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 30L19.2875 25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3374 26L16.2874 20",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.5C11 9.81886 11.4985 8.17547 12.4325 6.77766C13.3665 5.37984 14.694 4.29037 16.2472 3.64703C17.8004 3.00368 19.5094 2.83535 21.1583 3.16333C22.8071 3.4913 24.3217 4.30085 25.5104 5.4896C26.6992 6.67834 27.5087 8.1929 27.8367 9.84174C28.1647 11.4906 27.9963 13.1996 27.353 14.7528C26.7096 16.306 25.6202 17.6335 24.2223 18.5675C22.8245 19.5015 21.1811 20 19.5 20H9.5C8.04131 20 6.64236 19.4205 5.61091 18.3891C4.57946 17.3576 4 15.9587 4 14.5C4 13.0413 4.57946 11.6424 5.61091 10.6109C6.64236 9.57947 8.04131 9 9.5 9C10.1086 8.99687 10.7133 9.09835 11.2875 9.3",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloudRain);
export default __webpack_public_path__ + "static/media/ic_cloud_rain.77905cf11fa0242c35da18a05a6a922e.svg";
export { ForwardRef as ReactComponent };